/**Packages */
import React, { useState, useEffect } from 'react';
import CodiceFiscale from 'codice-fiscale-js';
import FormInputText from '../../shared/FormInputText';
//import { setDatiPersonali } from '../../../actions/index';

/**CSS */
import './fiscal.css';

const checkIfTextContainsNumber = (value = '') => {
  return /\d/.test(value);
}

const generateFiscalDataFromData = ({
  name = '',
  surname = '',
  gender = '',
  day = '',
  month = '',
  year = '',
  birthplace = '',
  birthplaceProvincia = '',
}) => {

  try {
    if (
      !name || name.length === 0
      || !surname || surname.length === 0
      || !gender || gender.length === 0
      || !day || day.length === 0
      || !month || month.length === 0
      || !year || year.length === 0
      || !birthplace || birthplace.length === 0
      || !birthplaceProvincia || birthplaceProvincia.length === 0
    ) return null;

    const cf = new CodiceFiscale({
      name,
      surname,
      gender,
      day,
      month,
      year,
      birthplace,
      birthplaceProvincia // Optional
    });

    return cf.isValid() ? cf : null;
  } catch (e) {
    //console.log(e);
    return null;
  }
}

export const FiscalCodeGenerator = ({
  onValidatedEvent = () => {},
  onInvalidatedEvent = () => { }
}) => {
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [gender, setGender] = useState("M");
  const [birthPlace, setBirthPlace] = useState("");
  const [birthRegion, setBirthRegion] = useState("");
  const [birthDay, setBirthDay] = useState("01");
  const [birthMonth, setBirthMonth] = useState("01");
  const [birthYear, setBirthYear] = useState("1980");
  const [availableYears, setAvailableYears] = useState([]);

  window.setTimeout(function () {
    window.$('select').SumoSelect();
    window.$("#birthDay").on("change", function () {
      setBirthDay(this.value);
    })
    window.$("#birthMonth").on("change", function () {
      setBirthMonth(this.value);
    })
    window.$("#birthYear").on("change", function () {
      setBirthYear(this.value);
    })
    window.$("#gender").on("change", function () {
      setGender(this.value);
    })
  }, 1000);

  const handleFirstName = (validation, event) => {
    const value = event.target.value;
    if (
      typeof value === "string"
      && !checkIfTextContainsNumber(value)
    ) {
      setFirstName(value);
    }
  }

  const handleLastName = (validation, event) => {
    const value = event.target.value;
    if (
      typeof value === "string"
      && !checkIfTextContainsNumber(value)
    ) {
      setLastName(value);
    }
  }

  const handleBirthPlace = (validation, event) => {
    const value = event.target.value;
    if (
      typeof value === "string"
      && !checkIfTextContainsNumber(value)
    ) {
      setBirthPlace(value);
    }
  }

  const handleBirthRegion = (validation, event) => {
    let value = event.target.value;
    if (typeof value == 'string') {
      value = value.toUpperCase();
    }
    if (
      typeof value === "string"
      && value.length <= 2
      && !checkIfTextContainsNumber(value)
    ) {
      setBirthRegion(value)
    }
  }

  useEffect(() => {
    // GMR - set availableYears items
    const currentYear = new Date().getFullYear();
    let _availableYears = [];
    for (let index = currentYear - 120; index < currentYear - 17; index++) {
      _availableYears.push(index);
    }
    _availableYears.sort(function (a, b) {
      if (a<b) {
        return 1;
      }
      return -1;
    })
    setAvailableYears(_availableYears);
  }, []);
  useEffect(() => {
    if (
      lastName !== ''
      && firstName !== ''
      && gender !== ''
      && birthPlace !== ''
      && birthRegion !== ''
      && birthRegion.length === 2
      && birthDay !== ''
      && birthMonth !== ''
      && birthYear !== ''
    ) {
      const cfResult = generateFiscalDataFromData({
        name: firstName,
        surname: lastName,
        gender,
        day: birthDay,
        month: birthMonth,
        year: birthYear,
        birthplace: birthPlace,
        birthplaceProvincia: birthRegion,
      });

      if (cfResult) {
        onValidatedEvent(cfResult)
      } else {
        onInvalidatedEvent();
      }
    }
  }, [
    lastName,
    firstName,
    gender,
    birthPlace,
    birthRegion,
    birthDay,
    birthMonth,
    birthYear
  ]);

  return (
    <div id="cfComposerCompressor">
      <div className="grid-x grid-margin-x" id="cfComposer">
        <div className="cell small-12">
          <h5>Calcola Codice Fiscale</h5>
          <FormInputText
            value={lastName}
            type="text"
            handler={handleLastName}
            label="Cognome*"
            name="Cognome"
            validate={"required"}
          />
        </div>
        <div className="cell small-8">
          <FormInputText
            value={firstName}
            type="text"
            handler={handleFirstName}
            label="Nome*"
            name="Nome"
            validate={"required"}
          />
        </div>
        <div className="cell small-4 text-center">
          <div className="form-item">
            <select
              className="custom-select"
              name="gender"
              id="gender"
              value={gender}
              onChange={(event) => setGender(event.target.value)}
            >
              {/* <option>Sesso</option> */}
              <option selected="selected" value="M">
                M
                          </option>
              <option value="F">F</option>
            </select>
          </div>
        </div>

        <div className="cell small-8">
          <FormInputText
            value={birthPlace}
            type="text"
            handler={handleBirthPlace}
            label="Luogo di nascita*"
            name="Luogo di nascita"
            validate={"required"}
          />
        </div>

        <div className="cell small-4">
          <FormInputText
            value={birthRegion}
            type="text"
            handler={handleBirthRegion}
            label="Prov."
            name="Prov."
            validate={"required"}
          />
        </div>

        <div className="cell small-12">
          <div className="form-item nascitaContainer">
            <div className="nascitaLabel">
              <label htmlFor="birthDay">Data di nascita</label>
            </div>
            <div className="nascitaValue">
              <select
                className="custom-select mr-2"
                name="birthDay"
                id="birthDay"
                value={birthDay}
                onChange={() => {
                  console.log("asd");
                }}
              >
                {/* <option>GG</option> */}
                <option selected="selected" value="01">
                  01
                            </option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
              </select>
              <select
                className="custom-select mr-2"
                name="birthMonth"
                id="birthMonth"
                value={birthMonth}
                onChange={(event) => setBirthMonth(event.target.value)}
              >
                {/* <option>MM</option> */}
                <option selected="selected" value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
              <select
                className="custom-select mr-2"
                name="birthYear"
                id="birthYear"
                value={birthYear}
                onChange={(event) => setBirthYear(event.target.value)}
              >
                {/* <option>AAAA</option> */}
                {availableYears.map((i) => (
                  <option
                    selected={1980 == i ? "selected" : "false"}
                    value={i}
                  >
                    {i}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/codice_fiscale/FiscalCodeGenerator/index.js